<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
            <v-card pa-0>
              <v-toolbar card color="white">
                <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Type something"
                v-model="search"
                hide-details
                @click:prepend="showFilter = !showFilter"
                @input="searchTerm"
                ></v-text-field>     
                <!--<v-btn icon>
                  <v-icon>filter_list</v-icon>
                </v-btn>-->
                            
                <v-btn @click="dialog=true; is_edit=false; fm={code:null,name:null,expired:null,kuota:null}" color="success" icon dark>
                  <v-icon>add</v-icon>
                </v-btn>                  
              </v-toolbar>
              <v-divider/> 
              <v-card-text v-if="showFilter">              
                <v-layout row wrap>                                
                  <v-flex md6 xs12>
                    <v-btn-toggle class="mr-3" v-model="toggle_gender" multiple dark>
                      <v-btn small flat class="red white--text" :value="1">L</v-btn>
                      <v-btn small flat class="blue-grey white--text"  :value="2">P</v-btn>              
                    </v-btn-toggle>  
                    <v-btn-toggle v-model="toggle_tingkat" class="mr-3" multiple dark>                
                      <v-btn round small v-for="(tingkat,i) in tingkats" :key="i" :value="tingkat.id" :color="getColor(tingkat.id)">{{tingkat.nama}}</v-btn>                
                    </v-btn-toggle> 

                  </v-flex>                
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-text class="pa-0 tabular">
                <v-data-table                
                  :headers="complex.headers"                
                  :items="complex.items"
                  :loading="complex.loading"
                  :pagination.sync="complex.options"
                  :rows-per-page-items="[{text:'All','value':-1}]"   
                  hide-actions             
                  >
                  <template slot="items" slot-scope="props">
                    <td>{{ ((complex.pagination.currentPage-1)*20)+(props.index+1) }}</td>                                   
                    <!--<td>{{ props.item.calon.user_id }}</td>-->
                    <td>{{ props.item.name }}</td>
                    <td><v-chip label small>{{ props.item.code }}</v-chip></td>                    
                    <td>{{ props.item.kuota }}</td>
                    <td>{{ props.item.expired ? $moment(props.item.expired*1000).format('LLL'):'(none)' }}</td>
                    <td class="text-xs-center">
                      <v-btn @click="editVoucher(props.item)" depressed icon class="green--text" small>
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn @click="deleteVoucher(props.item)" depressed icon class="red--text" small>
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
                <v-divider/>
                <div class="text-xs-center pa-2">
                  <v-pagination
                    v-model="complex.pagination.currentPage"
                    :length="complex.pagination.pageCount"
                    :total-visible="9"
                  ></v-pagination>
                </div>
              </v-card-text>            
            </v-card>
          </v-flex>                           
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
          <form @submit.prevent="createVoucher()">
            <v-card>
              <v-card-title class="headline">{{is_edit?'Edit':'Add new'}} voucher</v-card-title>
              <v-card-text>
                <v-text-field required label="nama voucher" v-model="fm.name" />  
                <v-text-field required label="kode voucher" v-model="fm.code" />  
                <v-text-field required type="number" label="kuota" v-model="fm.kuota" />
                <v-text-field type="datetime-local" label="expired" v-model="fm.expired" />  
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" flat @click="dialog = false">Cancel</v-btn>
                <v-btn type="submit" color="green darken-1" flat :loading="fmLoading">Simpan</v-btn>
              </v-card-actions>
            </v-card>
          </form>
        </v-dialog>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import { debounce } from 'lodash'
import Model from '@/apps/admin/models/master/Voucher';   
const  model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        formPath : '/signup/calon/payment/form',
        viewPath : '/signup/calon/payment/view',
        search   : '',
        loading  : true,
        toggle_tingkat : [],
        toggle_gender : [],
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: '#',   value: 'no'  },
              //{ text: 'ID',   value: 'id'  },
              { text: 'Name', value: 'name'},              
              { text: 'Code', value: 'code'}, 
              { text: 'Kuota', value: 'kuota'},
              { text: 'Expired', value: 'expired'},
              { text: 'Action', value: '', align:'center' },              
            ],
            items: [],
            loading : false,
            options : {},
            pagination:{
              totalCount: null,
              pageCount: 0,
              currentPage: 1,
              perPage: 20
            }
        },
        loadingDownload : false,
        tingkats : [],
        status   : [],
        types    : [],
        showFilter : false,
        payments:[],
        dialog:false,
        fm:{
          code:null,
          name:null,
          expired:null,
          kuota:null,
        }, fmLoading:false, is_edit:false
    }),  
    watch:{       
      'complex.pagination.currentPage'(newPage){        
        this.init(newPage) 
      },
      'complex.options':{
        handler(){          
          this.init(this.complex.pagination.currentPage)
        }, deep:true      
      },     
    },
    computed:{
    },
    mounted(){ 
      this.init(); 
    },            
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        getColor(tingkat){
          switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; default:return 'black';}
        },
        
        searchTerm:debounce(function (newText) {         
          this.init(this.complex.pagination.currentPage)                         
        }, 500),

        init(page = 1){
          this.complex.loading = true
          let  sortby = this.complex.options.sortBy ? this.complex.options.descending ? 
            '-'+this.complex.options.sortBy : this.complex.options.sortBy : 'id'; 

          const params = {
            'per-page': 20,
            page: page,
            q: this.search,
            //sort:sortby,              
          }
          this.complex.items = [];
          model.index(params).then(res => {      
              this.complex.items = res.data; 
              this.complex.pagination.pageCount = res.pagination.pageCount;  
              this.complex.loading = false;
          });                                         
        },                                                          

        createVoucher(){
          this.fmLoading = true;
          if(this.is_edit){
            model.update(this.fm).then((res)=>{
              if(res.status === 200){
                this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                            
                this.init()              
                this.dialog = false
              }
              this.fmLoading = false;
            });
          }else {
            model.create(this.fm).then((res)=>{
              if(res.status === 200){
                this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                            
                this.init()              
                this.dialog = false
              }
              this.fmLoading = false;
            });
          }                                         
        },

        editVoucher(item){
          this.dialog  = true;
          this.is_edit = true;
          Object.assign(this.fm, item)
          if(this.fm.expired){
            this.fm.expired = this.$moment(this.fm.expired*1000).format('YYYY-MM-DDTHH:mm')
          }           
        },

        deleteVoucher(item){
          this.$swal({title: 'Are you sure?', text: "You won't be able to revert this!",  type: 'warning',showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'}).then((result) => {                 
            if (result.value) { 
              model.delete({}, {id:item.id}).then(res=>{if(res.status === 200){
                this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                this.init()
              }});
            }
          });            
        }
    }
}
</script>
<style>
.tabular table.v-table tbody td:first-child, .tabular table.v-table tbody td:not(:first-child), .tabular table.v-table tfoot td:first-child, .tabular table.v-table tfoot td:not(:first-child), .tabular table.v-table tbody th:first-child, .tabular table.v-table tbody th:not(:first-child), .tabular table.v-table thead td:first-child, .tabular table.v-table thead td:not(:first-child), .tabular table.v-table thead th:first-child, .tabular table.v-table thead th:not(:first-child) {
    padding: 0 4px;
}
.tabular table.v-table tbody td:first-child, .tabular table.v-table thead th:first-child{
    padding: 0 7px 0 15px
}
</style>            